import { StringUuid } from "../domain/model/uuid/string-uuid";
import { Uuid } from "../domain/model/uuid/uuid.type";

export class SectionIdTrialIdUuid {
  readonly sectionId: Uuid;
  readonly trialId: Uuid;

  constructor(sectionId: Uuid, trialId: Uuid) {
    this.sectionId = sectionId;
    this.trialId = trialId;
  }

  asString(): string {
    return `${this.sectionId}${this.trialId}`;
  }

  toConcatedKey(): string {
    return `${this.sectionId.asString()}${this.trialId.asString()}`;
  }

  static fromStringSectionFirst(string: string): SectionIdTrialIdUuid {
    const sectionId = string.substring(0, StringUuid.uuidLength);
    const trialId = string.substring(
      StringUuid.uuidLength,
      StringUuid.uuidLength + StringUuid.uuidLength
    );
    return new SectionIdTrialIdUuid(new StringUuid(sectionId), new StringUuid(trialId));
  }
}
